import { functionAuthRequest } from 'services/API';
import { getHostingBucket } from 'services/Firebase';
import Bundle, { type BundleSchema } from './Bundle';
import DocumentCollection from './DocumentCollection';
import type Creative from './Creative';
import type Ad from './Ad';
import { query, orderBy } from 'firebase/firestore';
import { deleteObject } from 'firebase/storage';

export default class BundlesManager extends DocumentCollection<Bundle, BundleSchema> {
    uploading = false;
    currentFolder = '';
    uploadError = false;
    uploadErrorMessage = '';
    baseURL = getHostingBucket().websiteOrigin;
    query = () => query(this.collectionRef, orderBy('createTime'));

    constructor(parent: Creative) {
        super(parent, Bundle);
        this.becomeObservable();
    }

    new = async (bundleName: string, selectedAds: Array<Ad>) => {
        const adIDs: Array<string> = [];

        selectedAds.forEach(item => adIDs.push(item.id));

        await functionAuthRequest(
            'createBundleTask',
            {
                name: bundleName,
                selectedAdIDs: adIDs
            },
            this
        );
    }

    delete = async (id: string) => {
        const bundle = this.getById(id);
        if (!bundle) return;

        const hostingBucket = getHostingBucket();
        const allPaths = bundle.getAllStoragePaths();

        // Note that this code was updated to use the new service call
        // (getHostingBucket), but before that it assumed bundles were
        // stored in the app bucket and only ever tried to delete
        // `compositeArchivePath`, which was the outdated property. So this
        // likely hadn't been touched in a while. This code probably
        // will fail as the browser doesn't have write permission on the
        // hostingBucket. I don't know if this method even gets called.

        await Promise.all(allPaths.map((p) => deleteObject(hostingBucket.ref(p))));
        await bundle.delete();
    }

    getByStoragePath = (path: string) => {
        for (const item of this.all) {
            if (item.data.compositeArchivePath === path) return item;
        }
    }


    getByPath = (path: string) => { // TODO: this might not actually return whats needed.
        for (const item of this.all) {
            if (item.path === path) return item;
        }
    }


    getByName = (name: string) => {
        for (const item of this.all) {
            if (item.data.name === name) {
                return item;
            }
        }
    }
}

